// extracted by mini-css-extract-plugin
export default {"goBackButton":"styles_goBackButton__GtHOn"};